import React, { Component } from "react";
import sendLogError from "../../../sendLogError";

import Avatar from "react-avatar";
import ContextConstructor from "../../../components/Context/Context";
import binImg from "../../../images/Bin.svg";

class AssociadoMenorTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      associates: [],
      error: [],
      loading: true,
      associate: "",
      setassociateId: "",
    };
  }

  async componentDidMount() {
    this.populateAssociateData();
  }

  handleDelete = async (associateId) => {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
        };

        const response = await fetch(
            `/Profile/DeleteConnectionById?associateId=${associateId}`,
            {
                method: "DELETE",
                headers,
            }
        );

        if (response.status !== 204) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        // só redireciona se sucesso
        window.location.replace("/");

    } catch (error) {
        console.error("Error deleting connection:", error);

        sendLogError(error.message, "handleDelete");

        this.showErrorToast?.("Erro ao remover ligação. Tente novamente.");
    }
  };

getNameCapitalize = (name) => {
    if (name != []) {
      return name
        ?.toLowerCase()
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    }
    return name;
};

    getSafeDisplayName = (name) => {
        if (typeof name !== "string") return "";
        return this.getNameCapitalize(name);
    };

    render() {
        const safeName = this.getSafeDisplayName(associate?.name);

        return (
            <div>
            {this.state.associates.map((associate, i) => (
                <div className="User-Fields">
                    <div className="Same-Line-Fields">
                        <Avatar
                        color={"#E0E0E0"}
                        name={safeName}
                        round={true}
                        size={40}
                        style={{ fontWeight: "bold" }}
                        />
                        <label
                        style={{
                            fontWeight: "800",
                            color: "black",
                            paddingTop: "5px",
                            marginLeft: "10px",
                        }}>
                        {this.getNameCapitalize(associate.name)}
                        </label>
                        <input
                        type="image"
                        onClick={() => this.handleDelete(associate.associateId)}
                        src={binImg}
                        style={{ backgroundColor: "transparent", width: "40px", marginTop: "auto" }}
                        alt="remove"
                        />
                    </div>
                    <hr />
                    <div className="User-Fields">
                        <form>
                        <label>Nome</label>
                        <input
                            type="text"
                            name="Name"
                            readOnly="readOnly"
                            placeholder={this.getNameCapitalize(associate.name)}
                        />
                        </form>
                    </div>
                    <div className="Same-Line-Fields">
                        <form>
                        <label>NIF</label>
                        <input type="text" name="Nif" readOnly="readOnly" placeholder={associate.nif} />
                        </form>
                        <form className="right-form">
                        <label>Nº de Associado</label>
                        <input
                            type="text"
                            name="associateID"
                            readOnly="readOnly"
                            placeholder={associate.associate_Card_Number}
                        />
                        </form>
                    </div>
                    <br />
                </div>
            ))}
            </div>
        );
    }

  async populateAssociateData() {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
        };

        const response = await fetch("/Profile/GetMymAssociates", { headers });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        this.setState({
            associates: Array.isArray(data?.mymAssociates)
                ? data.mymAssociates
                : [],
            error: false,
            loading: false,
        });

    } catch (error) {
        console.error("Error fetching associates:", error);

        this.setState({
            error: true,
            loading: false,
            associates: [],
        });

        sendLogError(error.message, "populateAssociateData");
    }
  }
}

AssociadoMenorTab.contextType = ContextConstructor;

export default AssociadoMenorTab;

// async populateAssociateData() {
//     const headers = { Authorization: `Bearer ${authentication.getAccessToken()}`, 'Accept': 'application/json', 'Content-Type': 'application/json' };

//     const response = await fetch('/Profile/GetMymAssociates', {
//         method: 'get',
//         headers: headers
//        });
//     if (response.status != "200") {
//         this.setState({ error: true, loading: false });
// //           if (response.status === 204) appInsights.trackException({ exception: "Profile no content", severityLevel: 3 });
//     }
//     else {
//         const data = await response.json();
//         this.setState({ error: false, associates: data, loading: false });
//     }
// }

//contentStyle={{ "background": "none", "border": "none", "width": "auto", "backgroundColor": "initial" }}
